import { CSSProperties } from 'styled-components';

export const googleMapStyle: CSSProperties = {
  position: 'absolute',
  inset: '0',
  borderRadius: '8rem',
};
